<template>
  <v-card class="v-chip-link">
    <v-layout>

      <v-chip
        color="indigo"
        dark
        small
        @click="go('/consultor')"
      >
        {{ strings[idioma].inicio }}
      </v-chip>
      <v-chip
        color="indigo"
        dark
        small
        @click="go('/consultor?ref=clientes')"
      >
        {{ strings[idioma].clientes }}
      </v-chip>
      <v-chip
        color="indigo"
        dark
        small
        @click="go('/consultor?ref=relatorio')"
      >
        {{ strings[idioma].relatorios }}
      </v-chip>
      <v-chip
        color="indigo"
        dark
        small
        @click="go('/user')"
      >
        {{ strings[idioma].editar_perfil }}  {{ strings[idioma].consultor }}
      </v-chip>
    </v-layout>
  </v-card>

</template>
<script>
import { mapState } from 'vuex'
export default {
  data: () => ({
    logo: null
  }),
  computed: {
    ...mapState('app', ['strings', 'idioma', 'user', 'ingredientes', 'optionsNumber', 'alimentos_selecionados', 'categorias_alimentos', 'alert', 'dietas', 'predicoes', 'tabelas'])
  },
  methods: {
    getLogo () {
      this.axios.post('empresa/getLogo', { id: this.empresa.id }).then(res => {
        this.logo = res.data.data
      })
      return this.logo
    },
    go (url) {
      window.location.href = url
    },
    mudarEmpresa () {
      sessionStorage.removeItem('empresaAdm')
      this.go('/empresa')
    }
  }
}
</script>
